export default __webpack_public_path__ + "static/media/dashboard_team_members.7449f603.svg";